import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import '@/styles/main.scss';
import NjffForm from '@/forms/NjffForm';
import PartnerForm from '@/forms/PartnerForm';
import { FormValues, NJFF, Page, Partner } from '@/data/Types';
import { sendContactForm } from '@/services/contactService';

const FormContainer = () => {
    const [partner, setPartner] = useState<Partner>();
    const parsed = queryString.parse(window.location.search);

    const [page, setPage] = useState<Page>('personalInfo');
    const [sentError, setSentError] = useState(false);

    useEffect(() => {
        if (parsed?.partner) {
            setPartner(parsed.partner.toString().toUpperCase() as Partner);
        }
    }, [parsed]);

    const onSubmit = async (object: FormValues) => {
        try {
            await sendContactForm(object, partner || 'Ukjent partner');
            setSentError(false);
            setPage('receipt');
        } catch (e) {
            setSentError(true);
        }
    };
    switch (partner) {
        case NJFF:
            return (
                <NjffForm
                    onSubmit={onSubmit}
                    page={page}
                    setPage={setPage}
                    sentError={sentError}
                    removeSentError={() => setSentError(false)}
                />
            );
        default:
            return (
                <PartnerForm
                    onSubmit={onSubmit}
                    page={page}
                    setPage={setPage}
                    sentError={sentError}
                    removeSentError={() => setSentError(false)}
                />
            );
    }
};

export default FormContainer;
